import { useEffect } from "react";

import { useStore } from "@/state/store";
import { AppRoutes } from "@/routes";

/**
 * Root component del backoffice. Si occupa di:
 *  - Renderizzare le routes
 *  - Mostrare il toast globale (in modo non-bloccante in basso a destra)
 */
export function App() {
  const toast = useStore((s) => s.toast);
  const clearToast = useStore((s) => s.clearToast);

  // Permetti di chiudere manualmente il toast con ESC, oltre all'autodismiss.
  useEffect(() => {
    if (!toast) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") clearToast();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [toast, clearToast]);

  return (
    <>
      <AppRoutes />
      {toast && (
        <div className="fixed bottom-6 right-6 z-50">
          <div
            role="status"
            className={`card px-4 py-3 text-[13px] flex items-center gap-3 min-w-[280px] shadow-2xl ${
              toast.kind === "success"
                ? "border-yes/40 text-yes"
                : toast.kind === "error"
                  ? "border-no/40 text-no"
                  : "border-accent/40 text-accent-2"
            }`}
          >
            <span className="flex-1">{toast.message}</span>
            <button
              type="button"
              onClick={clearToast}
              className="text-muted hover:text-text text-[16px] leading-none"
              aria-label="Chiudi"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </>
  );
}
